import { render, staticRenderFns } from "./UnansweredCallBalloon.vue?vue&type=template&id=e3b1cd8a&scoped=true&"
import script from "./UnansweredCallBalloon.vue?vue&type=script&lang=js&"
export * from "./UnansweredCallBalloon.vue?vue&type=script&lang=js&"
import style0 from "./UnansweredCallBalloon.vue?vue&type=style&index=0&id=e3b1cd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b1cd8a",
  null
  
)

export default component.exports